<template>
  <section class="l-content-area">
    <div class="l-content l-content--login">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="p-bloc p-bloc__data-sync">
            <div class="p-data-sync__finish">
              <h2>大変申し訳ありません</h2>
              <p class="desc">予約の登録はできませんでした。下記の注意事項を確認の上、最初からやり直してください。</p>
              <div class="info-para">
                <h3><img src="../../assets/img/ui_parts/attention_icon.png" alt="MEN'S SVENSON" class="icon">予約に関する注意事項</h3>
                <ul>
                  <li>
                    通常メニュー予約の場合は、月２回までの予約とさせていただきます。同日の予約はできませんの で、ご了承いただきますようお願い申し上げます。
                  </li>
                  <li>
                    指定メニュー予約の場合は、月３回までの予約とさせていただきます。同日の予約はできませんので、ご了承いただきますようお願い申し上げます。ただし、通常メニューと指定メニューの組み合わせはできます。
                  </li>
                </ul>
              </div>
              <button-registration
                next-text="マイページトップへ"
                :is-prev-button="false"
                :handle-next-button="nextToStep"
              ></button-registration>
            </div>
          </section><!-- .p-bloc__data-sync -->
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ButtonRegistration from '../common/ButtonRegistration'
export default {
  name: 'DataSyncFailure',
  components: { ButtonRegistration },
  methods: {
    nextToStep() {
      this.$router.push({
        name: 'mypage'
      })
    }
  }
}
</script>
<style scoped>
  li {
    margin-bottom: 30px;
  }

  .info-para {
    background: #F5F5F5;
    padding: 4% 10% 7%;
  }

  p.desc {
    margin-bottom: 5%;
  }

  .p-data-sync__finish ul {
    margin-left: 0;
  }

  .v-application ul {
    padding-left: 0;
  }

  .icon {
    width: 21px;
    height: 18px;
    margin: 3px 10px 0 0;
  }

  h3 {
    margin-bottom: 3%;
  }

  .p-data-sync__finish {
    max-width: 680px;
}

@media only screen and (max-width: 500px) {
  .p-data-sync__finish ul {
    margin-left: 0;
  }
  .info-para {
    background: #F5F5F5;
    padding: 7% 10% 7%;
  }
}
</style>
